<template>
<div style="position:relative">
  <form @submit.prevent="input_submit">
   <input type="text"
      class="subinput"
      :disabled="disabled"
      :placeholder="placeholder"
      autocomplete="off"
      ref="inputbox"
      v-model="msg"
      v-on:keyup='input_keyup'>
   </b-form-input>
  </form>
</div>
</template>

<script>

export default {
  name: "InputSub",
  props: ["init", "value","disabled","placeholder"],
  components: {
  },
  watch: {
    value: function(to,from) {
      if ((""+to) != (""+this.msg)) {
        //console.log("value",">"+this.msg,">"+to);
        this.msg = to;
        this.prv_len = to.length;
      }
    },
  },
  data() {
    return  {
       input_disabled: false,
       msg: "",
       prv_len: 0,
    };
  },
  computed: {
  },
  mounted: function() {
    let vue = this;
    if (vue.init) {
       vue.msg = vue.init;
    } else if (vue.value) {
       vue.msg = ""+vue.value;
    }
  },
  methods: {
    input_keyup: function(ev) {
       let vue = this;
       let len = vue.msg.length;
       let val = vue.msg;
       //console.log("keyin: "+val,ev.keyCode,ev.key);
       vue.$emit("input",vue.msg);
       if (len > vue.prv_len) {
         // Printable character
         let char = val.substr(-1);
         let code = val.substr(-1).charCodeAt(0);
         vue.$emit("key",{keyCode:code, key: char});
       } else if (event.keyCode == 13) {
         // Filter out 'Enter' to force use of input_submit
         // since 'enter' may not work for some mobile devices
       } else {
         vue.$emit("key",{keyCode:ev.keyCode, key:ev.key});
       }
       vue.prv_len = len;
    },
    input_submit: function(ev) {
       let vue = this;
       vue.$emit("input",vue.msg);
       vue.$emit("enter");
    },
    scrollIntoView: function() {
       let vue = this;
       if (vue.$refs && vue.$refs.inputbox) {
          vue.$refs.inputbox.scrollIntoView();
       }
    },
    reset: function() {
      let vue = this;
      vue.msg = "";
      vue.$emit("input",vue.msg);
    },
    setfocus: function() {
      let vue = this;
      if (vue.$refs["inputbox"]) {
        vue.$refs["inputbox"].focus();
      }      
    },
  },
}
</script>

<style lang="scss" scoped>
.subinput {
  display: block;
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding-left:0.5rem;
}
</style>